import { defineSemantics } from "shared/theme/sidespor/define/semantics";
import { defineSlotRecipe } from "shared/theme/sidespor/define/slotRecipe";
import { SystemStyleObject } from "shared/theme/sidespor/types";

export const dialogRecipe = defineSlotRecipe({
  variants: {
    semantic: defineSemantics((theme) => ({
      content: {
        backgroundColor: theme.colorSemanticFillPulse,
        borderColor: theme.colorSemanticOutline,
        borderWidth: "1px",
      } as SystemStyleObject,
      body: {
        backgroundColor: theme.colorSemanticFill,
        borderColor: theme.colorSemanticOutline,
        borderWidth: "1px",
      },
    })),
  },
});
